import * as constants from '../constants';

export const setUserData = user => ({
  type: constants.SET_USER_DATA,
  payload: user
});
